<template>
  <el-button-group>
    <template v-if="isTextBtn">
      <el-button class="btn-text-cla"
                 :disabled="btn.status===0"
                 v-for="btn of items"
                 :key="btn.id"
                 @click="emit(btn.resourceEvent)"
                 type="text">
        <span>{{getButtonName(btn)}}</span>
      </el-button>
    </template>
    <template v-else-if="onlyIcon">
      <i :class="btn.icon"
         class="icon-btn-cla"
         v-for="btn of items"
         :key="btn.id"
         @click="emit(btn.resourceEvent)"></i>
    </template>
    <template v-else>
      <el-button style="text-align: center;"
                 :title="btn.status===0?this.$t('resource.disabled'):''"
                 :disabled="btn.status===0"
                 :circle="circle"
                 :round="round"
                 :size="size"
                 :plain="plain"
                 v-for="btn of items"
                 :key="btn.id"
                 @click="emit(btn.resourceEvent)"
                 :type="types[btn.resourceEvent]"
                 :icon="btn.icon">
        <span v-if="isShowText">{{getButtonName(btn)}}</span>
      </el-button>
    </template>
  </el-button-group>
</template>
<script>
export default {
  name: 'ZkOperateBar',
  data () {
    return {
      types: {
        update: 'primary',
        remove: 'danger',
        start: 'success',
        stop: 'danger'
      }
    }
  },
  props: {
    params: Object,
    isTextBtn: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    },
    showText: {
      type: Boolean,
      default: true
    },
    round: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    onlyIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isShowText () {
      if (typeof this.showText === 'undefined') {
        return true
      } else {
        return !!this.showText
      }
    },
    items () {
      if (this.$root.activeMenu.children) {
        return this.$root.activeMenu.children.filter((item) => {
          return item.resourceType === 4 || item.resourceType === '4'
        })
      } else {
        return []
      }
    }
  },
  methods: {
    getButtonName (Info) {
      let i18nKey = Info['i18nKey']
      if (i18nKey) {
        let value = this.$t(i18nKey)
        if (value !== i18nKey) {
          return value
        }
      }
      return Info.name
    },
    emit (event) {
      this.$emit(event, this.params)
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/styles/var.less';
.icon-btn-cla {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.9);
  letter-spacing: 0;
  margin-left: 8px;
  &:hover {
    color: @themeColor;
  }
}
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/operateBar/src/main.vue